import React from "react";
import heyLimeLogo from "assets/images/heyLimeLogo.png";
import dropdown from "assets/images/ct/ct-dropdown.png";
import Frame from "../../assets/images/chpt/Frame.png";
import hamburgerMenu from "../../assets/images/hamburger-menu.png";

const CHPTHeader = ({ users,currentUser ,status,PlayerGameInfo, toggle_dropdown = () => {}}) => {
  console.log("headerrrrr",status);
  const currentPlayer = users?.find(
    (user) => user.user_id === currentUser?.userId
  );


const PlayerScore = PlayerGameInfo?.find(
  (val) => val.player_id === currentPlayer?.player_id
)?.score||0;

  return (
    <div className="charty-party-header">
      <div className="score-contain">
     {  status != "Joining" &&  status != "Over" &&  <h5>SCORE</h5>}
       { status != "Joining" &&  status != "Over" && <div className="point">
          <img src={Frame} alt="bg" />
          <p> {PlayerScore}</p>
        </div>}
      </div>

      <div className="logo">
        <img alt="" src={heyLimeLogo} />
      </div>
      <div className="drop-down">
        <img alt="" src={hamburgerMenu} onClick={toggle_dropdown} />
      </div>
    </div>
  );
};

export default CHPTHeader;
